export default "/img/v11-0-0_fig4.0993d38738aaff608b46971cd7957946.png";